import VerifyBtn from '@/components/VerifyBtn/VerifyBtn';
import { accountManagementApi } from '@/api/user/accountManagementApi';
import { mapGetters, mapActions } from 'vuex';
import QRCode from 'qrcodejs2';
import { getErrorLabelMixin } from '@/common/mixin/getErrorLabel';
import { actionTypes } from '@/store/action-types';
import { getterTypes } from '@/store/getter-types';
import TextFieldComponent from '@/components/Form/TextField';

export default {
  name: 'GoogleVerificationBind',
  mixins: [getErrorLabelMixin],
  data() {
    return {
      rules: {
        gaCode: {
          required: true,
          numeric: true,
          length: 6
        }
      },
      currentStep: 'step1',
      isApp: true,
      deviceName: '', // 设备名称
      form: {
        secret: '', // 秘钥
        // validateCode: '',
        code: '',
      },
      // 查看谷歌验证器
      googleVerificationCheck: {
        code: '',
        secret: '',
        deviceName: '',
        otpAuthTotpURL: '',
        step: 'step1',
        committing: false,
      },
      // 用于生成二维码
      otpAuthTotpURL: '',
      // 二维码生成对象
      qrcodeObj: null,
      // 查看谷歌验证器对象
      qrcodeObj2: null,
      committing: false,
      // 判断秘钥数据是否已加载
      secretLoaded: false,
      // 控制关闭谷歌验证弹窗显示
      closeGoogleVerificationModalShow: true,
      // 关闭谷歌验证数据
      closeData: {
        code: '',
        emailCode: '',
        phoneCode: '',
        committing: false,
        isNeedPhoneCode: false, // 给校验器用，不用传递给后台
        isNeedEmailCode: false, // 给校验器用，不用传递给后台
      },
      showGaCode: false,
    };
  },
  methods: {
    ...mapActions([actionTypes.GET_USERINFO_ACTION]),
    // 开启谷歌验证按钮点击事件
    async confirmBtnClick() {
      let validated = await this.$refs.observer.validate();
      if (!validated || this.committing) {
        return;
      }
      this.committing = true;

      let data = {};
      // data.emailCode = this.form.validateCode;
      data.gaSecret = this.form.secret;
      data.gaCode = this.form.code;
      this._requestSetGoogleVerify(data);
    },
    // 获取秘钥
    async getSecret() {
      let res = await accountManagementApi.gaGenerate();
      let data = res.data;
      if (data) {
        this.secretLoaded = true;
      }
      this.form.secret = data.secretKey;
      this.deviceName = data.label;
      this.otpAuthTotpURL = data.otpAuthTotpURL;

      this.createQRCode();
    },
    // 查看谷歌验证按钮点击事件
    checkVerifyBtnClick() {
      // this.$v.googleVerificationCheck.$touch();
      // if (this.$v.googleVerificationCheck.$error || this.googleVerificationCheck.committing) {
      //   return;
      // }
      this.googleVerificationCheck.committing = true;
      this._requestCheckGoogleVerify(this.googleVerificationCheck.code);
    },
    // 关闭谷歌验证按钮点击事件
    closeGaVerifyBtnClick() {
      // this.$v.closeData.$touch();
      let req = /^\d{6}$/;
      let data = {};
      data.status = this.enableGaCheck === 1 ? 0 : 1;
      if (this.Getter_User_Info.enableEmailCheck) {
        if (this.closeData.emailCode && req.test(this.closeData.emailCode)) {
          data.emailCode = this.closeData.emailCode;
        } else {
          return;
        }
      }
      if (this.Getter_User_Info.enablePhoneCheck) {
        if (this.closeData.phoneCode && req.test(this.closeData.phoneCode)) {
          data.phoneCode = this.closeData.phoneCode;
        } else {
          return;
        }
      }
      if (this.closeData.code && req.test(this.closeData.code)) {
        data.gaCode = this.closeData.code;
      } else {
        return;
      }
      /* if (this.$v.closeData.$error || this.closeData.committing) {
        return;
      } */
      this.closeData.committing = true;
      this._requestCloseGoogleVerify(data);
    },
    // 生成二维码
    createQRCode() {
      if (!this.qrcodeObj) {
        this.qrcodeObj = new QRCode('google_code_qrcode', {
          text: this.otpAuthTotpURL,
          width: 108,
          height: 108,
          // colorDark : "#000000",
          // colorLight : "#ffffff",
          // (容错级别,支持L,M,H)Low/Middle/High
          // correctLevel : QRCode.CorrectLevel.H
        });
      } else {
        // 生成另外一个二维码
        this.qrcodeObj.makeCode(this.otpAuthTotpURL);
      }
    },
    // 生成查看谷歌验证二维码
    createQRCode2() {
      if (!this.qrcodeObj2) {
        this.qrcodeObj2 = new QRCode('view_qrcode', {
          text: this.googleVerificationCheck.otpAuthTotpURL,
          width: 108,
          height: 108,
          // colorDark : "#000000",
          // colorLight : "#ffffff",
          // (容错级别,支持L,M,H)Low/Middle/High
          // correctLevel : QRCode.CorrectLevel.H
        });
      } else {
        // 生成另外一个二维码
        this.qrcodeObj2.makeCode(this.googleVerificationCheck.otpAuthTotpURL);
      }
    },
    // 查看谷歌验证器
    _requestCheckGoogleVerify(code) {
      let checkData = this.googleVerificationCheck;
      accountManagementApi.checkGoogleVerify(code)
        .then(res => {
          let data = res.data;
          checkData.deviceName = data.label;
          checkData.otpAuthTotpURL = data.otpAuthTotpURL;
          checkData.secret = data.secret_key;

          checkData.committing = false;
          checkData.step = 'step2';
          this.$nextTick(() => {
            this.createQRCode2();
          });
        })
        .catch((err) => {
          checkData.committing = false;
        });
    },
    // 关闭谷歌验证器
    _requestCloseGoogleVerify(data) {
      accountManagementApi.closeGoogleVerify(data)
        .then(res => {
          this.closeData.committing = false;
          if (res.errcode === 0) {
            this.$q.notify({
              message: data.status === 1 ? '谷歌验证器已开启' : '谷歌验证器已关闭',
              // 可用的值: 'positive', 'negative', 'warning', 'info'
              type: 'positive',
              position: 'top', // 'top', 'left', 'bottom-left'等
            });
            this.closeGoogleVerificationModalShow = false;
            this.GET_USERINFO_ACTION();
            this.$router.replace('/usercenter/google-verification-bind');
          }
        })
        .catch(() => {
          this.closeData.committing = false;
        });
    },
    // 绑定谷歌验证器
    _requestSetGoogleVerify(data) {
      accountManagementApi.setGoogleVerify(data)
        .then((data) => {
          if (data.errcode === 0) {
            // this.$q.notify({
            //   message: this.$t('success.ga.bind'),
            //   // 可用的值: 'positive', 'negative', 'warning', 'info'
            //   type: 'positive',
            //   position: 'top', // 'top', 'left', 'bottom-left'等
            // });

            this.successNotify(this.$t('success.ga.bind'));

            this.$router.push('/usercenter/account-management');
          }
        })
        .catch(() => {
          this.committing = false;
        });
    },
    step1NextBtnClick(isApp) {
      this.currentStep = 'step2';
      this.isApp = isApp;
      if (!this.secretLoaded) {
        this.getSecret();
      }
    },
    step3NextBtnClick() {
      this.currentStep = 'step4';
    },
    copySuccess() {
      this.successNotify(this.$t('success.copy'));
    },
    copyError() {
      // this.$q.notify({
      //   message: '秘钥复制失败！',
      //   type: 'warning',
      //   position: 'top',
      // });
    },
    showModal() {
      this.closeGoogleVerificationModalShow = true;
      this.closeData.code = '';
      this.closeData.phoneCode = '';
      this.closeData.emailCode = '';
    },
    // 发送手机验证码条件
    sendPhoneValidCondition() {
      // this.$v.form.countryCode.$touch();
      // if (this.$v.form.countryCode.$error) {
      //   return false;
      // }
      if (this.Getter_User_Info.mobileStatus === 0) {
        // this.$v.form.mobile.$touch();
        // return !this.$v.form.mobile.$error;
      } else {
        // this.$v.form.newMobilePhone.$touch();
        // return !this.$v.form.newMobilePhone.$error;
      }
    },
  },
  computed: {
    ...mapGetters([getterTypes.Getter_User_Info]),
    errorMsgs() {
      let validateCodeRequired = this.Getter_User_Info.registerType === 1 ? '请填写手机验证码' : '请填写邮箱验证码';
      let validateCodeError = this.Getter_User_Info.registerType === 1 ? '手机验证码格式不正确' : '邮箱验证码格式不正确';
      return {
        validateCode: {
          required: validateCodeRequired,
          verifyCode: validateCodeError,
        },
        gaCode: {
          required: this.$t('v.common.gaCode.required'),
          gaCode: this.$t('v.common.gaCode.format'),
        },
        phoneCode: {
          requiredIf: '请输入手机验证码',
          phoneCode: '手机验证码格式不正确',
        },
        emailCode: {
          requiredIf: '请输入邮箱验证码',
          emailCode: '邮箱验证码格式不正确',
        },
      };
    },
    enableGaCheck() {
      return this.Getter_User_Info.enableGaCheck;
    },
  },
  components: {
    VerifyBtn,
    TextFieldComponent
  },
  watch: {
    Getter_User_Info(newval) {
      if (newval.enablePhoneCheck === 1) {
        this.closeData.isNeedPhoneCode = true;
      }
      if (newval.enableEmailCheck === 1) {
        this.closeData.isNeedEmailCode = true;
      }
    },
  },
  async created() {
    await this.GET_USERINFO_ACTION();
    let userInfo = this.Getter_User_Info;
    if (userInfo.enablePhoneCheck === 1) {
      this.closeData.isNeedPhoneCode = true;
    }
    if (userInfo.enableEmailCheck === 1) {
      this.closeData.isNeedEmailCode = true;
    }
    if (userInfo.gaStatus === 0) {
      this.getSecret();
    }
  },
};
